export default __webpack_public_path__ + "static/media/play_hover.2dbb3dd1.svg";